<div class="board">
	<div class="zk-flex zk-gap-2 zk-mb-5 zk-items-center">
		<span class="freud-icon freud-icon-plant freud-icon-sm"></span>
		<span class="board__title">{{
			'JOURNEY.JOURNEY_PROGRESS' | translate
		}}</span>
	</div>
	<div class="zk-flex zk-flex-col">
		<div class="zk-flex zk-flex-col">
			<span
				class="journey__appoint-title"
				freud-typography
				fontType="h6SemiboldAuto"
				>{{ 'JOURNEY.BOARD_SESSIONS' | translate }}</span
			>
			<div class="zk-text-start zk-py-3 zk-pl-2 line-height-5">
				<journey-appointment-icon
					class="zk-inline-block zk-mr-2"
					(click)="
						iTerapy.canRedirect &&
							iTerapy.id &&
							goTo.emit({ tab: 'promptuary', item: iTerapy.id })
					"
					*ngFor="let iTerapy of therapy; let i = index"
					[ngClass]="{ 'zk-cursor-pointer': iTerapy.canRedirect && iTerapy.id }"
					[status]="iTerapy.status"
					[registerBy]="iTerapy.registerBy.displayName"
					[index]="i + 1"
					[date]="iTerapy.completedAt"
				></journey-appointment-icon>
			</div>
		</div>
		<div class="zk-flex zk-flex-col" *ngIf="contents.length > 0">
			<div class="zk-flex zk-justify-between zk-items-center">
				<span
					class="journey__appoint-title"
					freud-typography
					fontType="h6SemiboldAuto"
				>
					{{ 'JOURNEY.BOARD_CONTENTS' | translate }}
				</span>
				<div
					(click)="goTo.emit({ tab: 'contents' })"
					class="zk-flex zk-gap-3 zk-items-center"
				>
					<span class="redirect__button zk-hidden sm:zk-inline">{{
						'JOURNEY.SEE_CONTENTS' | translate
					}}</span>
					<span
						class="freud-icon freud-icon-chevron-right freud-icon-md"
					></span>
				</div>
			</div>

			<div class="zk-text-start zk-py-3 zk-pl-2 line-height-5">
				<journey-appointment-icon
					(click)="goTo.emit({ tab: 'contents' })"
					class="zk-inline-block zk-mr-2 zk-cursor-pointer zk-cursor-pointer"
					*ngFor="let iContent of contents; let i = index"
					[status]="iContent.status"
					type="contents"
					[index]="i + 1"
					[date]="iContent.completedAt"
				></journey-appointment-icon>
			</div>
		</div>
		<div class="zk-flex zk-flex-col" *ngIf="evaluations.length > 0">
			<div class="zk-flex zk-justify-between zk-items-center">
				<span
					class="journey__appoint-title"
					freud-typography
					fontType="h6SemiboldAuto"
				>
					{{ 'JOURNEY.BOARD_EVALUATIONS' | translate }}
				</span>
				<div
					(click)="goTo.emit({ tab: 'evaluation' })"
					class="zk-flex zk-gap-3 zk-items-center zk-cursor-pointer"
				>
					<span class="redirect__button zk-hidden sm:zk-inline">{{
						'JOURNEY.SEE_EVALUATIONS' | translate
					}}</span>
					<span
						class="freud-icon freud-icon-chevron-right freud-icon-md"
					></span>
				</div>
			</div>

			<div class="zk-text-start zk-py-3 zk-pl-2 line-height-5">
				<journey-appointment-icon
					(click)="goTo.emit({ tab: 'evaluation', item: evaluation.id })"
					class="zk-inline-block zk-mr-2 zk-cursor-pointer"
					*ngFor="let evaluation of evaluations; let i = index"
					[ngClass]="{ 'zk-cursor-pointer': evaluation.status === 'completed' }"
					[status]="evaluation.status"
					type="evaluations"
					[index]="i + 1"
					[date]="evaluation.completedAt"
				></journey-appointment-icon>
			</div>
		</div>
		<div class="zk-flex zk-flex-col" *ngIf="psychiatry.length > 0">
			<span
				class="journey__appoint-title"
				freud-typography
				fontType="h6SemiboldAuto"
			>
				{{ 'JOURNEY.BOARD_PSYCHE' | translate }}
			</span>
			<div class="zk-text-start zk-py-3 zk-pl-2 line-height-5">
				<journey-appointment-icon
					class="zk-inline-block zk-mr-2"
					*ngFor="let iPsychistry of psychiatry; let i = index"
					(click)="iPsychistry.canRedirect && goTo.emit({ tab: 'psychiatry' })"
					[ngClass]="{ 'zk-cursor-pointer': iPsychistry.canRedirect }"
					[status]="iPsychistry.status"
					[index]="i + 1"
					[date]="iPsychistry.completedAt"
				></journey-appointment-icon>
			</div>
		</div>
	</div>
</div>
